import React, { useState, memo } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { Star } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'premium' | 'standard'>('premium');
  const plans = {
    standard: {
      href: 'https://pago.biomalivido.com/cart/45328607871167:1',
      label: '🌿 QUIERO MI SISTEMA CLARIDAD DIGESTIVA'
    },
    premium: {
      href: 'https://pago.biomalivido.com/cart/45493439430847:1',
      label: '🌿 QUIERO EL SISTEMA + CEREBRO DE CRISTAL'
    }
  };
  return <section id="pricing" className="bg-brand-dark relative" data-id="element-170">
      {/* Urgency countdown with dark red background - full width */}
      <div className="bg-[#1a0808] py-24" data-id="element-171">
        <div className="container mx-auto px-4" data-id="element-172">
          <div className="max-w-5xl mx-auto text-center" data-id="element-173">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-174">
              <h2 className="text-2xl font-bold mb-6 flex items-center justify-center gap-2 text-[#FFFFFF]" data-id="element-175">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA PRONTO
              </h2>
              <CountdownTimer data-id="element-176" />
              <p className="text-gray-400 mt-6 mb-4 flex items-center justify-center gap-2" data-id="element-177">
                <span className="text-yellow-500" data-id="element-178">⚠️</span> Después sube.{' '}
                <span className="text-white font-bold" data-id="element-179">No vuelve.</span>
              </p>

              <div className="max-w-md mx-auto bg-brand-black p-4 rounded-xl border border-red-500/20" data-id="element-180">
                <div className="flex justify-between text-sm mb-2 text-red-400 font-medium" data-id="element-181">
                  <span data-id="element-182">🔴 Quedan pocos cupos al precio de lanzamiento</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2.5" data-id="element-183">
                  <div className="bg-red-500 h-2.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-184"></div>
                </div>
                <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-185">
                  68% de los cupos ya tomados
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Pricing cards */}
      <div className="container mx-auto px-4 py-16 md:py-24" data-id="element-186">
        <div className="max-w-5xl mx-auto" data-id="element-187">
          <div className="text-center mb-8 md:mb-12" data-id="element-188">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-189">
              ELEGÍ TU SISTEMA
            </h2>
          </div>

          <div className="flex flex-col gap-4 md:grid md:grid-cols-2 md:gap-8 md:items-stretch max-w-lg md:max-w-5xl mx-auto" data-id="element-190">
            {/* Standard Plan */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} onClick={() => setSelected('standard')} className={`bg-brand-black border rounded-2xl md:rounded-3xl p-4 md:p-8 flex flex-col cursor-pointer transition-colors ${selected === 'standard' ? 'border-brand-green' : 'border-gray-700 hover:border-gray-500'}`} data-id="element-191">
              <div className="flex items-start gap-3" data-id="element-192">
                {/* Radio button */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected === 'standard' ? 'border-brand-green' : 'border-gray-600'}`} data-id="element-193">
                  {selected === 'standard' && <div className="w-2.5 h-2.5 rounded-full bg-brand-green" data-id="element-194" />}
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0" data-id="element-195">
                  <div className="flex items-start justify-between gap-2" data-id="element-196">
                    <div data-id="element-197">
                      <div className="text-sm font-bold text-brand-light mb-0.5" data-id="element-198">
                        📗 SISTEMA CLARIDAD DIGESTIVA™
                      </div>
                      <p className="text-sm text-gray-400" data-id="element-199">5 Tomos + 5 Bonos</p>
                      <p className="text-xs text-brand-green mt-1.5 font-medium" data-id="element-200">
                        Ideal para: La mujer de 55+ con niebla mental, olvidos
                        frecuentes o fatiga cognitiva
                      </p>
                    </div>
                    <div className="text-right shrink-0" data-id="element-201">
                      <div className="text-gray-500 line-through text-sm" data-id="element-202">
                        $52.000
                      </div>
                      <div className="text-2xl md:text-4xl font-bold text-white leading-tight" data-id="element-203">
                        $19.990
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-204">ARS</div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Premium Plan */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} onClick={() => setSelected('premium')} className={`bg-brand-black rounded-2xl md:rounded-3xl p-4 md:p-8 flex flex-col cursor-pointer transition-colors relative ${selected === 'premium' ? 'border-2 border-brand-green shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border border-gray-700 hover:border-gray-500'}`} data-id="element-205">
              <div className="flex items-start gap-3" data-id="element-206">
                {/* Radio button */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected === 'premium' ? 'border-brand-green' : 'border-gray-600'}`} data-id="element-207">
                  {selected === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-brand-green" data-id="element-208" />}
                </div>

                {/* Content */}
                <div className="flex-grow min-w-0" data-id="element-209">
                  <div className="flex items-start justify-between gap-2" data-id="element-210">
                    <div data-id="element-211">
                      <div className="text-sm font-bold text-brand-gold mb-0.5 flex items-center gap-1" data-id="element-212">
                        🏆 SISTEMA + CEREBRO DE CRISTAL™
                      </div>
                      <div className="flex items-center gap-1.5 mb-0.5" data-id="element-213">
                        <Star className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-214" />
                        <span className="text-xs font-bold text-brand-gold" data-id="element-215">
                          MÁS ELEGIDO
                        </span>
                      </div>
                      <p className="text-sm text-gray-400" data-id="element-216">
                        5 Tomos + 5 Bonos + Protocolo Avanzado de Mielina
                      </p>
                      <p className="text-xs text-brand-green mt-1.5 font-medium" data-id="element-217">
                        Ideal para: Blindar tu memoria para los próximos 20 años
                      </p>
                    </div>
                    <div className="text-right shrink-0" data-id="element-218">
                      <div className="text-gray-500 line-through text-sm" data-id="element-219">
                        $69.000
                      </div>
                      <div className="text-2xl md:text-4xl font-bold text-brand-green leading-tight" data-id="element-220">
                        $27.990
                      </div>
                      <div className="text-xs text-gray-400" data-id="element-221">ARS</div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Single CTA Button */}
          <div className="max-w-lg md:max-w-2xl mx-auto mt-6 md:mt-10" data-id="element-222">
            <Button href={plans[selected].href} showBadges className="w-full py-4 text-base md:text-lg bg-brand-green hover:bg-brand-light" data-id="element-223">
              → {plans[selected].label}
            </Button>
          </div>
        </div>
      </div>
    </section>;
}